import { createAsyncThunk } from '@reduxjs/toolkit';

import { getErrorMessage } from '@/shared/utils/error';

import type { EscritorioConvite, ListarConvitesFilters } from '@/types/escritorio/escritorioTypes';

import type { ConvidarComSetoresDto } from '../../types/convitesTenant';

import { convitesTenantService } from './services';

export const listarConvitesDoTenant = createAsyncThunk<
  EscritorioConvite[],
  { escritorioId: string; filters?: ListarConvitesFilters },
  { rejectValue: string }
>('adminGeral/convitesTenant/listar', async ({ escritorioId, filters }, { rejectWithValue }) => {
  try {
    return await convitesTenantService.listar(escritorioId, filters);
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Erro ao listar convites do escritório'));
  }
});

export const convidarParaTenant = createAsyncThunk<
  { convites: EscritorioConvite[]; totalEnviados: number },
  { escritorioId: string; data: ConvidarComSetoresDto },
  { rejectValue: string }
>('adminGeral/convitesTenant/convidar', async ({ escritorioId, data }, { rejectWithValue }) => {
  try {
    return await convitesTenantService.convidar(escritorioId, data);
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Erro ao enviar o convite'));
  }
});

export const cancelarConviteDoTenant = createAsyncThunk<
  void,
  { escritorioId: string; conviteId: string },
  { rejectValue: string }
>(
  'adminGeral/convitesTenant/cancelar',
  async ({ escritorioId, conviteId }, { rejectWithValue }) => {
    try {
      await convitesTenantService.cancelar(escritorioId, conviteId);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Erro ao cancelar o convite'));
    }
  },
);
